import { X, Check } from "lucide-react";
import { Reveal, SectionTag, ArrowDoodle } from "@/components/doodles";

const OLD = [
  "Cookie-cutter programs for everyone",
  "Intimidation is the vibe",
  "Aesthetics above everything",
  "You're a membership number",
  "Quietly quitting by week 3",
];

const NEW = [
  "A plan built for your body & your season of life",
  "Encouragement-first coaching",
  "Capability & confidence over filters",
  "A coach who knows your name — and your story",
  "Faith, purpose & grit baked in",
];

export const WhyMe = () => (
  <section id="why" className="py-24 sm:py-32">
    <div className="max-w-6xl mx-auto px-5 sm:px-8">
      <div className="text-center max-w-3xl mx-auto">
        <Reveal><SectionTag className="text-pink">WHY TRAIN WITH ME</SectionTag></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-3 leading-[0.95]">
            NOT YOUR AVERAGE <span className="text-stroke">GYM BRO</span> PROGRAM.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="relative inline-block mt-4">
            <p className="font-hand text-2xl sm:text-3xl text-pink -rotate-2">real talk:</p>
            <ArrowDoodle className="w-16 h-16 rotate-[200deg] text-pink absolute -left-20 -top-6 hidden sm:block" />
          </div>
        </Reveal>
      </div>

      <div className="mt-12 grid lg:grid-cols-2 gap-8 items-stretch">
        <Reveal className="h-full">
          <div className="h-full bg-offwhite border-[3px] border-ink/25 p-8 sm:p-10" data-testid="why-old-card">
            <p className="font-bebas tracking-[0.25em] text-lg text-ink/50">THE BIG-BOX GYM EXPERIENCE</p>
            <ul className="mt-6 space-y-4">
              {OLD.map((o) => (
                <li key={o} className="flex items-start gap-3 text-base sm:text-lg font-semibold text-ink/45">
                  <span className="mt-1 w-5 h-5 shrink-0 border-2 border-ink/30 flex items-center justify-center">
                    <X className="w-3.5 h-3.5 text-ink/40" strokeWidth={3} />
                  </span>
                  <span className="line-through decoration-ink/25">{o}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="h-full">
          <div className="relative h-full card-pop bg-white p-8 sm:p-10 rotate-1" data-testid="why-new-card">
            <span className="absolute -top-4 right-6 bg-pink text-cream border-[2.5px] border-ink font-hand text-xl px-3 py-0.5 shadow-[3px_3px_0_#0d0d0d] rotate-3">
              the evolve way
            </span>
            <p className="font-bebas tracking-[0.25em] text-lg text-pink">THE EVOLVE WITH ROSA EXPERIENCE</p>
            <ul className="mt-6 space-y-4">
              {NEW.map((n) => (
                <li key={n} className="flex items-start gap-3 text-base sm:text-lg font-bold text-ink">
                  <span className="mt-1 w-5 h-5 shrink-0 bg-lime border-2 border-ink flex items-center justify-center">
                    <Check className="w-3.5 h-3.5" strokeWidth={3.5} />
                  </span>
                  {n}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
